export default __webpack_public_path__ + "static/sbp-14d25e1017841c9941e69916c83aed2c.svg";